import React from 'react'
import PropTypes from 'prop-types'
import { Element } from 'react-scroll'
import MasterData from '../../data/MasterData'
import images from '../../assets/images/train/*.svg'

export default class Train extends React.Component {
  static propTypes = {
    train: PropTypes.object.isRequired,
    duplicateTrains: PropTypes.array,
    trainIconSettings: PropTypes.object.isRequired
  }

  static contextTypes = {
    intl: PropTypes.object
  }

  static TRAIN_KIND_CLASS = {
    0: 'is_color_limitedExpress',
    1: 'is_color_express',
    2: 'is_color_rapid',
    3: 'is_color_rapid',
    4: 'is_color_local',
  }

  static TRAIN_DIRECTION_CLASS = {
    'up': 'is_up',
    'down': 'is_down'
  }

  get delayElement() {
    const { train } = this.props
    if (100 <= train.delay) {
      return <div className="d-TrainPosition-trainNote"><span>+99</span></div>
    } else if (1 <= train.delay && train.delay <= 99) {
      return <div className="d-TrainPosition-trainNote"><span>+{train.delay}</span></div>
    } else {
      return ''
    }
  }

  trainKindClass(trainKindId, direction) {
    return `d-TrainPosition-train ${Train.TRAIN_KIND_CLASS[trainKindId]} ${Train.TRAIN_DIRECTION_CLASS[direction]}`
  }

  handleTrainClick = () => {
    const { url } = this.props.match
    const { train } = this.props
    var train_info_url = url + "/" + train.train_number
    if (train.duplicate) {
      train_info_url = url + "/info/" + train.train_number
    }

    this.props.history.push({
      pathname: train_info_url
    })
  }

  specialIconUrl() {
    const { train, trainIconSettings } = this.props
    const conditions = trainIconSettings.conditions
    if (!conditions || conditions.length === 0) return false

    const hitCondition = conditions.find(condition => {
      const update_date = this.updateDate()
      if (condition.start_at && (update_date < this.parthStringToDate(condition.start_at))) return false
      if (condition.end_at && (update_date > this.parthStringToDate(condition.end_at))) return false

      const lineKind = MasterData.lineKind(train.station_id)
      if (condition.line_kinds && !condition.line_kinds.includes(lineKind)) return false

      if (condition.train_kind_ids && !condition.train_kind_ids.includes(train.train_kind_id)) return false

      const trainNumber = train.train_number.substr(0,2)
      if (condition.train_numbers && !condition.train_numbers.includes(trainNumber)) return false

      if (condition.car_numbers && !train.car_numbers.some((checkNumber) => condition.car_numbers.includes(checkNumber))) return false

      if (condition.required_car_numbers && !condition.required_car_numbers.every((requiredNumber) => train.car_numbers.includes(requiredNumber))) return false

      const stations = this.stations()
      const trainStationindex = stations.findIndex(station => station.id === train.station_id)
      if (condition.station_start_at) {
        const startStationIndex = stations.findIndex(station => station.id === condition.station_start_at)
        if (startStationIndex < 0) return false
        if (trainStationindex < startStationIndex ) return false
      }
      if (condition.station_end_at) {
        const endStationIndex = stations.findIndex(station => station.id === condition.station_end_at)
        if (endStationIndex < 0 ) return false
        if ((trainStationindex > endStationIndex)
          || ((trainStationindex === endStationIndex) && train.next_station_id)
        ) return false
      }

      return true
    });
    return hitCondition ? hitCondition.icon_url : undefined
  }

  // "YYYY/MM/DD HH:mm:ss"のフォーマットの文字列から時差日本での指定時間のDateを生成
  parthStringToDate(string) {
    return new Date(`${string.replaceAll("/", "-").replace(" ", "T")}+0900`)
  }

  updateDate() {
    const { lineName, nankai_update_date, nankai_update_time, koya_update_date, koya_update_time } = this.props
    return lineName == "nankai" ? this.parthStringToDate(`${nankai_update_date} ${nankai_update_time}`) : this.parthStringToDate(`${koya_update_date} ${koya_update_time}`)
  }
 
  stations() {
    const { lineName, lines } = this.props
    const lineId = MasterData.lineIdByLineName(lineName)
    return lines.find(l => l.line_id === lineId).stations
  }

  imageUrl(trainKind) {
    const specialIconUrl = this.specialIconUrl()
    if (specialIconUrl) return specialIconUrl

    // 列車種別判定
    return images[trainKind.image_name]
  }

  render() {
    const { train, duplicateTrains, lineName } = this.props
    var kind = ""
    if (lineName === "nankai") {
      kind = MasterData.nankaiTrainKindById(train.train_kind_id)
    } else {
      kind = MasterData.koyaTrainKindById(train.train_kind_id)
    }
    const image_url = this.imageUrl(kind)

    if(kind.train_type === '回送' || kind.train_type === '' ) return null

    let trainAnchorLinks = [<Element key={`train${train.train_number}`} id={`train${train.train_number}`} className={`d-TrainPosition-anchorlink`} />]
                            .concat(duplicateTrains.map(train => <Element key={`train${train.train_number}`} id={`train${train.train_number}`} className={`d-TrainPosition-anchorlink`} />))

    return (
        <a onClick={this.handleTrainClick} className={this.trainKindClass(train.train_kind_id, train.direction)}>
          {trainAnchorLinks}
          <div className="d-TrainPosition-trainDirection"></div>
          <div className="d-TrainPosition-trainIcon">
            {train.duplicate ? <img src={images["train_multi"]} /> : <img src={image_url} />}
          </div>
          {this.delayElement}
        </a>
    )
  }
}
